export default __webpack_public_path__ + "src/images/btn_skip-031a4b.png";